export const categorizeProducts = (products) => {
    const categories = {};

    products.forEach(product => {
        const { category, subcategory, subcategory2, subcategory3 } = product;

        if (!category) return;

        if (!categories[category]) {
            categories[category] = {};
        }

        if (!subcategory) {
            if (!categories[category].products) {
                return;
            }
            categories[category].products.push(product);
            return;
        }

        if (!categories[category][subcategory]) {
            categories[category][subcategory] = {};
        }

        if (!subcategory2) {
            if (!categories[category][subcategory].products) {
                categories[category][subcategory].products = [];
            }
            categories[category][subcategory].products.push(product);
            return;
        }

        if (!categories[category][subcategory][subcategory2]) {
            categories[category][subcategory][subcategory2] = {};
        }

        if (!subcategory3) {
            if (!categories[category][subcategory][subcategory2].products) {
                categories[category][subcategory][subcategory2].products = [];
            }
            categories[category][subcategory][subcategory2].products.push(product);
            return;
        }

        if (!categories[category][subcategory][subcategory2][subcategory3]) {
            categories[category][subcategory][subcategory2][subcategory3] = [];
        }

        categories[category][subcategory][subcategory2][subcategory3].push(product);
    });

    return categories;
};